import { InjectionToken } from '@angular/core';
import { ABTestConfig } from './abtest.interface';

export const ABTEST_CONFIG = new InjectionToken<ABTestConfig>('ABTestConfig');



// WEBPACK FOOTER //
// ./src/@freelancer/abtest/abtest.config.ts